import {propsReducer} from "utils/stateUtils";
import {CONTRACTOR_SET_PROPS} from "actions";

const DEFAULT_STATE = {
  contractors:[],
  contractorDetails:null
};

export default propsReducer(CONTRACTOR_SET_PROPS, DEFAULT_STATE);
